var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "lightbox" },
    [
      _c("vue-easy-lightbox", {
        attrs: {
          moveDisabled: "",
          visible: _vm.visible,
          imgs: _vm.imgs,
          index: _vm.index,
        },
        on: { hide: _vm.hide },
        scopedSlots: _vm._u([
          {
            key: "toolbar",
            fn: function () {
              return [_vm._v(" ")]
            },
            proxy: true,
          },
        ]),
      }),
      _vm._v(" "),
      _c(
        "button",
        { class: this.className, on: { click: () => _vm.show() } },
        [_vm._t("default")],
        2
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }